import { ensureJourneyStyles } from './journeyStyles';
import { useLayoutEffect, useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import ClinicalFooter from './clinical-footer';
import JourneyLoading from './JourneyLoading';

export default function JourneyLayout() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [styleState, setStyleState] = useState<'loading' | 'ready' | 'failed'>('loading');
  const [attempt, setAttempt] = useState(0);
  useLayoutEffect(() => {
    const link = ensureJourneyStyles();
    const ready = () => setStyleState('ready');
    const failed = () => {
      link.remove();
      setStyleState('failed');
    };
    const timer = window.setTimeout(failed, 15000);
    const loaded = () => {
      window.clearTimeout(timer);
      ready();
    };
    const errored = () => {
      window.clearTimeout(timer);
      failed();
    };
    if (link.sheet || link.dataset.edJourneyLoaded === 'true') loaded();
    else setStyleState('loading');
    link.addEventListener('load', loaded);
    link.addEventListener('error', errored);
    document.body.classList.add('talo-app-active');
    return () => {
      window.clearTimeout(timer);
      link.removeEventListener('load', loaded);
      link.removeEventListener('error', errored);
      document.body.classList.remove('talo-app-active');
    };
  }, [attempt]);
  if (styleState !== 'ready') {
    return (
      <div style={{ minHeight: '100vh', background: '#fffdf7', color: '#1a3736', fontFamily: 'Arial, sans-serif' }}>
        {styleState === 'failed' ? (
          <div role="alert" style={{ padding: 24 }}>
            <p>We couldn’t load this page. Please try again.</p>
            <button type="button" onClick={() => setAttempt((value) => value + 1)}>
              Try again
            </button>
          </div>
        ) : (
          <JourneyLoading />
        )}
      </div>
    );
  }
  return (
    <div
      className={'brand-site talo-home talo-app' + (pathname.endsWith('/complete-order') ? ' talo-checkout-page' : '')}
    >
      <header className="talo-app-header assessment-header">
        <button type="button" className="talo-app-back" onClick={() => navigate(-1)}>
          <ChevronLeft size={20} />
          Back
        </button>
        <Link to="/" aria-label="Talo home">
          <img
            src="/talo-next/brand/talo-logo.webp"
            alt="Talo"
            width={90}
            height={39}
            style={{ maxWidth: 90, height: 'auto' }}
          />
        </Link>
        <span />
      </header>
      <main id="main" className="talo-app-content talo-app-clinical">
        <Outlet />
      </main>
      <ClinicalFooter />
    </div>
  );
}
